module.exports = __webpack_public_path__ + "img/header.59a492fc.jpg";